/**
 * Roles and Permissions Constants
 * Contains all role types, role enums, and permission-related constants
 */

export enum ROLE_TYPES {
  Evaluatee = 'Evaluatee',
  Evaluator = 'Evaluator',
  Shared = 'Shared',
}

export enum Role {
  Admin = 1,
  AdminChapter = 2,
  Evaluator = 3,
  TeamEvaluator = 14,
}

export enum RolItemEnum {
  CHAPTER = 'chapter',
  SPECIALITY = 'speciality',
  PROFILE = 'perfil',
  FOCUSING = 'enfoque',
  EQUIVALENT_ROLE = 'rol equivalente',
}

export enum RolPermisiions {
  VIEW_ID = 1,
  EDIT_ID = 2,
}
